
import axios from 'axios'
const RESOURCE_NAME_QEUSTION_LIST = '/api/SurveyClientData/CompositeQuestionText'
const RESOURCE_NAME_ClientDataWithSegmentation = '/api/SurveyClientData/ClientDataWithSegmentation'
const RESOURCE_NAME_ClientDataWithCohort = '/api/SurveyClientData/ClientDataWithCohort'

export const SegmentService = {
    getQuestionList,
    getClientDataWithSegmentation,
    GetClientDataWithCohort
};

function getQuestionList(filters, cb, errorCb) {
    axios
        .post(RESOURCE_NAME_QEUSTION_LIST, filters)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}

function getClientDataWithSegmentation(filters, cb, errorCb) {
    axios
        .post(RESOURCE_NAME_ClientDataWithSegmentation, filters)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}

function GetClientDataWithCohort(filters, cb, errorCb) {
    axios
        .post(RESOURCE_NAME_ClientDataWithCohort, filters)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}